import './utils/check';
import 'babel-polyfill';
import Vue from 'vue';
import antAdminX, { GET, POST, DELETE, PUT, breadParam } from 'ant-design-vue-admin-x';
import App from './App.vue';
import router from './router';
import store from './store';
import './utils/common';
import './utils/vlidator';
import '@/utils/platform';
import './permission';
import moment from 'moment';
import 'moment/locale/zh-cn';
import Antd, { message } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import UIPackage from './components';

import Highcharts from 'highcharts/highstock';
import HighMaps from 'highcharts/modules/map';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsDrilldown from 'highcharts/modules/drilldown';
import Highcharts3D from 'highcharts/highcharts-3d';
import variablePie from 'highcharts/modules/variable-pie';
import chartOptions from './utils/chartOptions';

moment.locale('zh-cn');

Vue.use(Antd);
Vue.use(antAdminX);
Vue.use(UIPackage);

HighMaps(Highcharts);
HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
variablePie(Highcharts);

Highcharts.setOptions(chartOptions.setOptions);
Vue.prototype.Moment = moment;
Vue.prototype.Highcharts = Highcharts;
Vue.prototype.breadParam = breadParam;

const config = { baseURL: process.env.VUE_APP_BASE_API_JAVA };
const _get = GET.bind(config);
const _post = POST.bind(config);
const _delete = DELETE.bind(config);
const _put = PUT.bind(config);

Vue.prototype._get = _get;
Vue.prototype._post = _post;
Vue.prototype._delete = _delete;
Vue.prototype._put = _put;

Vue.prototype.$get = GET;
Vue.prototype.$post = POST;
Vue.prototype.$delete = DELETE;
Vue.prototype.$put = PUT;

message.config({ maxCount: 1 });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
